import React from 'react';
import IconNextStyled from './IconNext.styled';

const IconNext = props => (
  <IconNextStyled viewBox="0 0 24 30" {...props}>
    <title>Next noodle</title>
    <path d="M12.994 4.988a1 1 0 0 0-.698 1.717l4.293 4.293H5.011a1 1 0 1 0 0 2H16.59l-4.293 4.293a1 1 0 1 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-.716-.303z" />
  </IconNextStyled>
);

export default IconNext;



// WEBPACK FOOTER //
// ./src/components/atoms/IconNext/IconNext.js